exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2-djj1zqzhEwa8F1t3f8-5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3Mm3VuXUuHJ7QD8pjh0LZ4{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._3Mm3VuXUuHJ7QD8pjh0LZ4:not(:last-child) ._2hbU2_7D2CrkbTGBYK5lYx{border-right:none}._2hbU2_7D2CrkbTGBYK5lYx{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:0;width:100%}._1HnvyI4fsZNcgrnND15ulz>svg{fill:transparent;height:1.2em;stroke:currentColor;stroke-dasharray:2;stroke-width:1;width:1.2em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkButtons": "_2-djj1zqzhEwa8F1t3f8-5",
	"MarkButtons_buttonContainer": "_3Mm3VuXUuHJ7QD8pjh0LZ4",
	"MarkButtons_button": "_2hbU2_7D2CrkbTGBYK5lYx",
	"MarkButtons_PartialIcon": "_1HnvyI4fsZNcgrnND15ulz"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/PaperBased/MarkHomeworkDayView/Student/MarkButtons/style.postcss
// module id = 1683
// module chunks = 0